import { watch } from "vue";
import { useRoute } from "vue-router";

import { createRoutePerformanceTracker } from "@/composables/routePerformance.mjs";
import {
  createPerformanceRouteMarker,
  markPerformanceMilestone,
} from "@/utils/performanceTelemetry.mjs";

export function useRoutePerformance(routeGroup = "") {
  const route = useRoute();
  const tracker = createRoutePerformanceTracker({
    route,
    routeGroup,
    createRouteMarker: createPerformanceRouteMarker,
    markFallback: markPerformanceMilestone,
  });

  watch(
    () => route.fullPath,
    () => tracker.refresh(route),
    { flush: "sync" },
  );

  const mark = (metricName, data = {}) => {
    tracker.refreshIfChanged(route);
    return tracker.mark(metricName, data);
  };

  return {
    markShellReady: (data = {}) => mark("route_shell_ready", data),
    markDataReady: (data = {}) => mark("route_data_ready", data),
    markInteractionReady: (data = {}) =>
      mark("route_interaction_ready", data),
    markRouteError: (data = {}) =>
      mark("route_error", {
        value: 1,
        rating: "poor",
        ...data,
      }),
  };
}
